module.exports = __webpack_public_path__ + "img/ty1.3a12efb8.png";